import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import BrandLegalPassthroughRequirementsPage from "@faire/prototype-playground/workspace/tl/brand-legal-passthrough-requirements";
import UpmarketPlusLegalPassthroughRequirementsPage from "@faire/prototype-playground/workspace/tl/upmarket-plus-legal-passthrough-requirements";

const BrandHomePage = lazy(
  () =>
    import("@faire/prototype-playground/workspace/tl/brand-legal-passthrough-requirements/HomePage")
);

const BrandOrdersPage = lazy(
  () =>
    import("@faire/prototype-playground/workspace/tl/brand-legal-passthrough-requirements/OrdersPage")
);

const MomofukuBrandPage = lazy(
  () =>
    import("@faire/prototype-playground/workspace/tl/upmarket-plus-legal-passthrough-requirements/BrandPage")
);

const ComplianceDocumentsPage = lazy(
  () =>
    import("@faire/prototype-playground/workspace/tl/upmarket-plus-legal-passthrough-requirements/ComplianceDocumentsPage")
);

const MessengerPage = lazy(
  () =>
    import("@faire/prototype-playground/workspace/tl/upmarket-plus-legal-passthrough-requirements/MessengerPage")
);

export function TaneishaLugoRoutes() {
  return (
    <Switch>
      <Route
        exact
        path="/tl/brand-legal-passthrough-requirements"
        component={BrandHomePage}
      />
      <Route
        path="/tl/brand-legal-passthrough-requirements/messenger"
        component={BrandLegalPassthroughRequirementsPage}
      />
      <Route
        path="/tl/brand-legal-passthrough-requirements/orders"
        component={BrandOrdersPage}
      />
      <Route
        exact
        path="/tl/upmarket-plus-legal-passthrough-requirements"
        component={UpmarketPlusLegalPassthroughRequirementsPage}
      />
      <Route
        path="/tl/upmarket-plus-legal-passthrough-requirements/brand/momofuku"
        component={MomofukuBrandPage}
      />
      <Route
        path="/tl/upmarket-plus-legal-passthrough-requirements/compliance-documents"
        component={ComplianceDocumentsPage}
      />
      <Route
        path="/tl/upmarket-plus-legal-passthrough-requirements/messenger/momofuku"
        component={MessengerPage}
      />
    </Switch>
  );
}

export const slug = "tl";
